export default "__VITE_ASSET__Cj5y5Mmq__"